import React, { useContext, useEffect } from "react"
import CampaignCard from "./CampaignCard"
import CampaignCardSkeleton from "./CampaignCardSkeleton"
import { LangContext } from "../../LangProvider"
import { LoadingHelper } from "../../components"
import { useFetchApi } from "../../hooks"

function OurCampaign() {
  const { lang } = useContext(LangContext)
  const [{ data: campaigns, loading }, doFetch] = useFetchApi(
    `/campaigns?lang=${lang}`,
    []
  )

  useEffect(() => {
    doFetch(`/campaigns?lang=${lang}`, [])
  }, [lang])

  return (
    <div className="uk-container uk-margin-large-bottom uk-margin-large-top" uk-slider="sets: true">
      <div className="uk-position-relative" tabIndex="1">
        <div className="uk-slider-container">
          <ul className="uk-slider-items uk-child-width-1-3" uk-grid="true">
            {loading ? (
              <LoadingHelper>
                <CampaignCardSkeleton />
              </LoadingHelper>
            ) : (
              campaigns.map(campaign => (
                <li key={campaign._id}>
                  <CampaignCard campaign={campaign} />
                </li>
              ))
            )}
          </ul>
        </div>

        <button
          className="uk-position-center-left-out uk-position-small uk-hidden-hover uk-text-secondary"
          uk-slidenav-previous="true"
          uk-slider-item="previous"
        ></button>
        <button
          className="uk-position-center-right-out uk-position-small uk-hidden-hover uk-text-secondary"
          uk-slidenav-next="true"
          uk-slider-item="next"
        ></button>
        <ul className="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>
      </div>
    </div>
  )
}

export default OurCampaign
